import {
  GetTrafficRequest,
  TrafficDataSet,
  TrafficH3ByPolygonRequest,
  TrafficH3Datum,
  TrafficResponse,
  TrafficSegmentResponse,
} from 'src/common-services'
import { convertToObjects } from 'src/common-services/utils/result-processing'
import { BaseClient } from 'src/common-services/clients/base-client'

export class TrafficClient extends BaseClient {
  getTraffic(data: GetTrafficRequest): Promise<TrafficResponse> {
    return this.call('/traffic', 'POST', { data })
  }

  getSegmentStats(year: TrafficDataSet, segmentId: string): Promise<TrafficSegmentResponse> {
    return this.call(`/traffic/segments/${encodeURIComponent(year)}/${encodeURIComponent(segmentId)}`, 'GET')
  }

  async getH3sByPolygon(request: TrafficH3ByPolygonRequest): Promise<TrafficH3Datum[]> {
    const res = await this.post<Array<string | number>[]>('/traffic/h3/by-polygon', request)
    return convertToObjects(request.fields, res)
  }
}
